export default "<svg width=\"18\" height=\"18\">\n</svg>"